<template>
  <v-dialog
    v-model="isOpen"
    :class="['modal-dialog', { 'modal-dialog-full': isTabOpen }]"
  >
    <v-card class="modal-card">
      <v-card-title class="modal-title">
        <h2 class="modal-title-text">Change Slides</h2>
        <v-icon @click="handleClose">mdi-close</v-icon>
      </v-card-title>
      <div class="modal-divider-wrapper">
        <span class="modal-divider"></span>
      </div>

      <v-card-text>
        <div class="modal-content-center">
          <img src="/images/doc-slide-dec.svg" alt="" />
          <h1 class="modal-heading">Attach a Google Slides</h1>
          <p class="modal-description">
            Please attach a Google Slide link below.
          </p>
        </div>

        <div class="input-wrapper">
          <span class="input-icon-left">
            <img src="/images/link.svg" alt="link" />
          </span>
          <BaseInput
            v-model="localDrive"
            type="text"
            class="input-full-width"
            placeholder="drive.google.com"
          />
          <span v-if="localDrive" class="input-icon-right">
            <img src="/images/color-link.svg" alt="delete icon" />
          </span>
          <span v-else class="input-icon-right">
            <img src="/images/link-slide.svg" alt="delete icon" />
          </span>
        </div>

        <p v-if="!isTabOpen" class="modal-note">
          NOTE: Uploading a new Google Slide link will cause the existing slides
          for this lesson to be overwritten.
        </p>
        <div class="text-center">
          <small>Google Slides is a trademark of Google Inc.</small>
        </div>

        <button
          class="btn-primary btn-upload"
          @click="handleUpload"
          :disabled="!localDrive"
        >
          Upload Slide Deck
        </button>

        <div v-if="isTabOpen" class="tabs">
          <p class="tabs-label">Choose slides</p>
          <span
            class="tab"
            :class="{ active2: activeTab2 === 'opening' }"
            @click="setActiveTab2('opening')"
            >Opening Activity</span
          >
          <span
            class="tab"
            :class="{ active2: activeTab2 === 'main-activity' }"
            @click="setActiveTab2('main-activity')"
            >Main Activity</span
          >
          <span
            class="tab"
            :class="{ active2: activeTab2 === 'closing-activity' }"
            @click="setActiveTab2('closing-activity')"
            >Closing Activity</span
          >
        </div>
        <div v-if="isTabOpen" class="content">
          <div v-if="activeTab2 === 'opening'" class="content-padding">
            <p class="selected-count">
              ({{ slides.filter((slide) => slide.value).length }})Selected
            </p>
            <div class="select-all-wrapper">
              <input
                class="checkbox-input"
                type="checkbox"
                id="select-all"
                :checked="isAllSelected"
                @change="toggleSelectAll"
              />
              <label for="select-all" class="checkbox-label">
                Select All
              </label>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-1"
                    v-model="slide1"
                  />
                  <label for="slide-1" class="checkbox-label"> Slide 3 </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-2"
                    v-model="slide2"
                  />
                  <label for="slide-2" class="checkbox-label"> Slide 3 </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-3"
                    v-model="slide3"
                  />
                  <label for="slide-3" class="checkbox-label"> Slide 3 </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>
          </div>

          <div v-if="activeTab2 === 'main-activity'" class="content-padding">
            <div class="select-all-wrapper">
              <input
                class="checkbox-input"
                type="checkbox"
                id="select-all-main"
                :checked="isAllSelected"
                @change="toggleSelectAll"
              />
              <label for="select-all-main" class="checkbox-label">
                Select All
              </label>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-main-1"
                    v-model="slide1"
                  />
                  <label for="slide-main-1" class="checkbox-label">
                    Slide 3
                  </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-main-2"
                    v-model="slide2"
                  />
                  <label for="slide-main-2" class="checkbox-label">
                    Slide 3
                  </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-main-3"
                    v-model="slide3"
                  />
                  <label for="slide-main-3" class="checkbox-label">
                    Slide 3
                  </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>
          </div>

          <div v-if="activeTab2 === 'closing-activity'" class="content-padding">
            <div class="select-all-wrapper">
              <input
                class="checkbox-input"
                type="checkbox"
                id="select-all-closing"
                :checked="isAllSelected"
                @change="toggleSelectAll"
              />
              <label for="select-all-closing" class="checkbox-label">
                Select All
              </label>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-closing-1"
                    v-model="slide1"
                  />
                  <label for="slide-closing-1" class="checkbox-label">
                    Slide 3
                  </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-closing-2"
                    v-model="slide2"
                  />
                  <label for="slide-closing-2" class="checkbox-label">
                    Slide 3
                  </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>

            <div class="slide-item">
              <div class="slide-item-left">
                <div class="slide-checkbox-wrapper">
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    id="slide-closing-3"
                    v-model="slide3"
                  />
                  <label for="slide-closing-3" class="checkbox-label">
                    Slide 3
                  </label>
                </div>

                <img
                  src="/images/content.svg"
                  alt="Slide Image"
                  class="slide-image"
                />
              </div>

              <div>
                <p class="slide-description">
                  Introduce the learners to the ground rules. You can check out
                  the Eddy Approach if this is your first time conducting an
                  Eddy lesson.
                </p>
              </div>
            </div>
          </div>

          <div class="pagination-wrapper">
            <v-pagination v-model="page" :length="5" class="pagination">
              <template v-slot:item="{ props, isActive }">
                <button
                  v-bind="props"
                  :class="[
                    'pagination-button',
                    { 'pagination-button-active': isActive },
                  ]"
                >
                  {{ extractPageNumber(props["aria-label"]) }}
                </button>
              </template>
            </v-pagination>

            <button class="btn-confirm" @click="handleConfirm">Confirm</button>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed, watch, defineProps, defineEmits } from "vue";
import BaseInput from "../BaseInput.vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  drive: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(["update:modelValue", "confirm", "close"]);

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const localDrive = ref(props.drive || null);
const isTabOpen = ref(false);
const activeTab2 = ref("opening");
const page = ref(1);
const slide1 = ref(false);
const slide2 = ref(false);
const slide3 = ref(false);
const slides = [slide1, slide2, slide3];

watch(
  () => props.drive,
  (newValue) => {
    localDrive.value = newValue;
  }
);

watch(
  () => props.modelValue,
  (newValue) => {
    if (!newValue) {
      isTabOpen.value = false;
      activeTab2.value = "opening";
      localDrive.value = props.drive || null;
    }
  }
);

const isAllSelected = computed(() => slides.every((slide) => slide.value));

const toggleSelectAll = () => {
  const newState = !isAllSelected.value;
  slides.forEach((slide) => (slide.value = newState));
};

const setActiveTab2 = (tabName) => {
  activeTab2.value = tabName;
};

const extractPageNumber = (ariaLabel) => {
  const match = ariaLabel.match(/page (\d+)/i);
  return match ? match[1] : "";
};

const handleUpload = () => {
  isTabOpen.value = true;
};

const handleClose = () => {
  isOpen.value = false;
  emit("close");
};

const handleConfirm = () => {
  emit("confirm", localDrive.value);
};
</script>

<style scoped>
.modal-dialog {
  width: 600px;
}

.modal-dialog-full {
  width: auto;
}

.modal-card {
  border-radius: 16px;
}

.modal-title {
  display: flex;
  justify-content: space-between;
}

.modal-title-text {
  color: var(--primary-blue);
  font-size: var(--fs-big);
  font-weight: 600;
}

.modal-divider-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}

.modal-divider {
  width: 94%;
  border: solid 1px #f2f3fc;
}

.modal-content-center {
  width: 100%;
  text-align: center;
  margin-bottom: 10px;
}

.modal-heading {
  color: var(--primary-blue);
  font-size: 32px;
  font-weight: 600;
}

.modal-description {
  font-size: var(--fs-big);
  font-weight: 400;
}

.input-wrapper {
  position: relative;
}

.input-icon-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 5px;
}

.input-icon-right {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  margin-top: 5px;
  margin-right: 3px;
}

.input-full-width {
  width: 100%;
}

.modal-note {
  font-size: 12px;
  font-weight: 400;
  margin-top: 5px;
}

.text-center {
  text-align: center;
}

.btn-primary {
  color: white;
  background-color: var(--primary-blue);
  font-size: var(--fs-big);
  padding: 7px;
  border-radius: 16px;
  font-weight: 600;
  width: 100%;
  margin-top: 32px;
  margin-bottom: 40px;
  border: none;
  cursor: pointer;
}

.btn-primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.tabs-label {
  font-size: var(--fs-medium);
  font-weight: 400;
  margin-bottom: 15px;
}

.selected-count {
  font-size: var(--fs-medium);
  font-weight: 400;
  margin-bottom: 20px;
}

.select-all-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.checkbox-input {
  height: 20px;
  width: 20px;
  margin-right: 5px;
}

.checkbox-label {
  cursor: pointer;
  font-weight: 400;
  font-size: var(--fs-medium);
}

.slide-item {
  display: flex;
  gap: 1rem;
  border-top: 1.5px solid #ddd;
  padding-top: 10px;
  background-color: #fff;
  margin-bottom: 1rem;
}

.slide-item-left {
  display: flex;
  flex-direction: column;
  border-right: 1.5px solid #ddd;
  padding-right: 10px;
}

.slide-checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.slide-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
}

.slide-description {
  margin: 0;
}

.pagination-wrapper {
  margin-top: 30px;
  display: flex;
  width: 100%;
  justify-content: center;
  margin-left: auto;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.pagination-button {
  width: 40px;
  height: 40px;
  border-radius: 30%;
  font-size: var(--fs-medium);
  font-weight: bold;
  border: 1px solid #e0e0e0;
  background-color: white;
  color: #cccccc;
  cursor: pointer;
  transition: all 0.3s ease;
}

.pagination-button-active {
  background-color: var(--primary-blue);
  color: white;
}

.btn-confirm {
  background-color: var(--primary-blue);
  color: white;
  padding: 10px;
  border-radius: 16px;
  font-size: 17px;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.content-padding {
  padding: 0.5rem 0;
}

.content {
  font-family: "League Spartan";
  font-size: var(--fs-medium);
}

.tab {
  cursor: pointer;
  padding: 8px 16px;
  margin-right: 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.active2 {
  background-color: var(--primary-blue);
  color: white;
}
</style>
